import React, { useContext } from 'react';
import ModalContext from '../Modal/ModalContext';
import CommentForm from '../CommentForm';

// Use this component as the base for a modal comment
// form so that the modal's buttons have access to submit the form.
function ModalCommentForm(props) {
  const {
    setSubmitFn,
    setSubmitDisabled,
  } = useContext(ModalContext);

  return (
    <CommentForm
      {...props}
      setOuterSubmitFn={setSubmitFn}
      setOuterSubmitDisabled={setSubmitDisabled}
    />
  );
}

export default ModalCommentForm;
